import React, { useMemo } from 'react';
import { useEffect } from 'react';
import moment from 'moment';
import { minutesSinceMidnight, timeGrid, timeToMinutes } from 'helpers/generalHelpers.js';
import { getCurrentUserAwakeTime, getCurrentUserBedTime, getTestMode } from 'store/storeValtio';

export default function MedicationTimePicker({doseCount, doses, setTime, curTime}) {
  //console.log('MedTimePicker', doseCount, doses, curTime);
  //const [mnan, setMNAN] = useState('M');
  const testMode = getTestMode();
  const tg = timeGrid();
  //console.log(tg);
  const period = useMemo(() => [
    {key: 'D', when: 'Dawn'},
    {key: 'M', when: 'Morning'},
    {key: 'N', when: 'Noon'},
    {key: 'A', when: 'Afternoon'},
    {key: 'E', when: 'Evening'},
    {key: 'T', when: 'Night'}
  ],[]);

  useEffect(() => {
    const awake = getCurrentUserAwakeTime();
    var awakeMin = timeToMinutes(awake);
    var pos = Math.floor(awakeMin/15) * 15;  // make 15 minute interval
    //var pos = 360; // set for morning - 360 min from midnight
    //console.log(awake, awakeMin, pos);
    if (curTime) {
      // use time to set initial scroll position
      const msm = minutesSinceMidnight(curTime);
      const msm15 = (Math.floor(msm / 15) * 15);
      //console.log(msm, msm15);
      pos = msm15;
    } else if (doseCount > 1) {
      // otherwise scroll to position based on doses/doseCount
      const bed = getCurrentUserBedTime();
      const bedMin = timeToMinutes(bed);
      const minAwake = bedMin - awakeMin;
      // get number of 15 minute intervals while awake per dose
      const numInt = Math.floor((minAwake / 15) / doses);
      const offset = numInt * (doseCount-1) * 15;
      pos = awakeMin + offset;
      //console.log(doses, doseCount, numInt, awakeMin, offset, pos);
    }

    //console.log('uE', pos);
    scrollTo(pos);
  }, [doses,doseCount]);

  function selectMNAN(when) {
    //console.log("MNAN",when);
    switch (when) {
      case 'D':
        scrollTo(20*15);
        break;
      case 'M':
        scrollTo(32*15);
        break;
      case 'N':
        scrollTo(48*15);
        break;
      case 'A':
        scrollTo(64*15);
        break;
      case 'E':
        scrollTo(72*15);
        break;
      case 'T':
        scrollTo(88*15);
        break;
      default:
        break;
    }
    //setMNAN(when);  // force refresh
  }

  function scrollTo(pos) {
    //console.log('scrollTo',pos);
    const p = `.li${pos}`;
    if (!p) return;
    document.querySelector(p).scrollIntoView({block: 'center'});
  }
  
  function selectTime(t, ix) {
    //console.log('selectTime', t, ix);
    setTime(t);
  }

  return (
    <>
      <div className="flex justify-center text-xl font-semibold mb-1">
        <div className="grid grid-cols-3 grid-rows-2">
          {period.map((p,ix) => {
              return (
                <div className='w-full border-2 border-slate-500 rounded-md p-2 text-center mb-1 bg-slate-200'
                  key={p.key} 
                  onClick={() => selectMNAN(p.key)}
                  >
                  {p.when}
                </div>
                )
          })}
        </div>
      </div>
      {/* <ul className='medPeriod'>
        {period.map((p,ix) => {
            return (
              <li 
                key={p.key} 
                className='rawBtn' 
                onClick={() => selectMNAN(p.key)}
                >
                {p.when}
              </li>
              )
        })}
      </ul> */}
      <div className='timeList mb-2'>
        <ul className='snap-y snap-mandatory'>
          {tg.map((t, ix) => {
            //console.log(ix, t);
            const cl = `li${t.min}`;
            return (
              <li 
                key={ix}
                className={`${cl} rawBtn w-full border-2 border-gray-400 text-blue bg-blue-300 hover:bg-blue-600 hover:cursor-pointer snap-start scroll-m-0`}
                onClick={() => selectTime(t.time, ix)}
                >
                  {t.time}{testMode ? ` (${t.min})` : ''}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}
